export default __webpack_public_path__ + "static/media/female-mesomorph.75009ac0.svg";